import React from "react";
import TableDataList from "../TableDataList";
import TableList from "./TableList";
interface ListWrapperProps {
  data: any[];
  context: string;
  onRowAction?: (action: string, row: any) => void;
  selectedRowItem?: any | null;
  onRowSelect?: (row: any | null, index: number) => void;
  currentRecord?: (index: number) => void;
}

const TableListWrapper: React.FC<ListWrapperProps> = ({
  data,
  context,
  onRowAction = (action, row) => console.log(`${action} row:`, row), // Default handler
  selectedRowItem,
  onRowSelect,
  currentRecord,
}) => {
  return (
    <TableList
      context={context}
      data={data}
      handleRowAction={onRowAction}
      selectedRowItem={selectedRowItem}
      setCurrentRecord={currentRecord}
    />
  );
};

export default TableListWrapper;
